var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrationsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.936628 4.52235C0.419343 4.52235 2.26114e-08 4.10301 0 3.58573C-1.4632e-08 3.25098 0.175604 2.95725 0.439716 2.79163L2.95702 0.274333C3.32279 -0.091444 3.91583 -0.091444 4.28161 0.274332C4.64739 0.640108 4.64739 1.23315 4.28161 1.59892L3.23144 2.6491L10.3029 2.6491C10.8202 2.6491 11.2395 3.06844 11.2395 3.58573C11.2395 4.10301 10.8202 4.52235 10.3029 4.52235L0.982944 4.52235C0.974401 4.52247 0.965856 4.52247 0.957312 4.52235H0.936628Z",
    fill: "#202020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0634 6.36583C14.5807 6.36583 15 6.78517 15 7.30246C15 7.6372 14.8244 7.93093 14.5603 8.09655L12.043 10.6138C11.6772 10.9796 11.0842 10.9796 10.7184 10.6139C10.3526 10.2481 10.3526 9.65503 10.7184 9.28926L11.7686 8.23908H4.69709C4.1798 8.23908 3.76046 7.81974 3.76046 7.30246C3.76046 6.78517 4.1798 6.36583 4.69709 6.36583L14.0171 6.36583C14.0256 6.36571 14.0341 6.36571 14.0427 6.36583H14.0634Z",
    fill: "#202020"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationsIcon);
export default __webpack_public_path__ + "static/media/integrations-icon.f343de8b.svg";
export { ForwardRef as ReactComponent };